// This file is autogenerated. Please add your changes to routeConfig.ts instead.


//#region types
import { RouteInfo } from "models/utilTypes/routeTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components

//#endregion

export const RouteDescriptions: Array<RouteInfo> = [
  {
    path: "",
    
    exact: true,
    displayText: TranslationKeys.Common.Dashboard,
  },
  {
    path: "AllCompanies",
    
    displayText: TranslationKeys.Todos.AllCompanies,
  },
  {
    path: "Reports",
    displayText: TranslationKeys.Common.Reports,
    children: [
      {
        path: "Articles",
        
        displayText: TranslationKeys.Common.Articles,
      },
      {
        path: "Revenue",
        displayText: TranslationKeys.Common.Revenue,
        disableBackNavigation: true,
        children: [
          {
            path: "Invoices",
            
            displayText: TranslationKeys.Invoice.CustomerInvoices,
          },
          {
            path: "RecurringInvoices",
            
            displayText: TranslationKeys.Invoice.RecurringInvoices,
          },
          {
            path: "CashReconciliations",
            
            displayText: TranslationKeys.CashReconciliation.CashReconciliations,
          },
          {
            path: "Projects",
            
            displayText: TranslationKeys.TimeReportingProject.TimeReportingProjects,
          },
        ],
      },
      {
        path: "Expenses",
        displayText: TranslationKeys.Common.Expenses,
        disableBackNavigation: true,
        children: [
          {
            path: "IncomingInvoices",
            
            displayText: TranslationKeys.Reports.IncomingInvoices,
          },
          {
            path: "Receipts",
            
            displayText: TranslationKeys.Reports.Receipts,
          },
        ],
      },
      {
        path: "DocumentDrafts",
        
        displayText: TranslationKeys.DocumentDraft.ReceivedDocuments,
      },
      {
        path: "Customers",
        
        displayText: TranslationKeys.Customer.Customers,
      },
      {
        path: "Quotes",
        
        displayText: TranslationKeys.Invoice.Quotes,
      },
      {
        path: "IncomingInvoices",
        
        displayText: TranslationKeys.IncomingInvoice.IncomingInvoices,
      },
      {
        path: "Suppliers",
        
        displayText: TranslationKeys.Supplier.Supplier,
      },
      {
        path: "AllToDos",
        
        displayText: TranslationKeys.Common.Todo,
      },
      {
        path: "Board",
        
        displayText: TranslationKeys.Reports.Board,
      },
      {
        path: "IncomeStatement",
        
        displayText: TranslationKeys.Accounting.IncomeStatement,
      },
      {
        path: "BalanceSheet",
        
        displayText: TranslationKeys.Accounting.BalanceSheet,
      },
      {
        path: "SharedDocuments",
        
        displayText: TranslationKeys.Document.SharedDocuments,
      },
      {
        path: "SIE",
        
        displayText: TranslationKeys.Document.SIEFiles,
      },
      {
        path: "AccountingDocuments",
        
        displayText: TranslationKeys.Document.GenericDocuments,
      },
      {
        path: "BusinessUnits",
        
        displayText: TranslationKeys.BusinessUnit.BusinessUnits,
      },
      {
        path: "Projects",
        
        displayText: TranslationKeys.TimeReporting.Projects,
      },
      {
        path: "Accounting",
        
        displayText: TranslationKeys.Common.Accounting,
      },
      {
        path: "Agreements",
        
        displayText: TranslationKeys.Common.Agreement,
      },
      {
        path: "Automations",
        
        displayText: TranslationKeys.Common.Automation,
      },
      {
        path: "FinancialStatements",
        
        displayText: TranslationKeys.Common.FinancialStatements,
      },
      {
        path: "QualifiedShareDividend",
        
        displayText: TranslationKeys.Common.K10Forms,
      },
      {
        path: "ReconciliationReport",
        
        displayText: TranslationKeys.Accounting.Reconciliation,
      },
      {
        path: "DeadlineReport",
        
        displayText: TranslationKeys.Common.Deadline,
      },
      {
        path: "HoldingRegisters",
        displayText: TranslationKeys.HoldingRegister.HoldingRegister,
        
      },
      {
        path: "HoldingRegister",
        displayText: TranslationKeys.HoldingRegister.HoldingRegister,
        backNavigationPath: "Reports/HoldingRegisters",
        children: [
          {
            path: ":id",
            
            displayText: TranslationKeys.HoldingRegister.HoldingRegister,
          },
        ],
      },
      {
        path: "ExportedFilesView",
        
        displayText: TranslationKeys.Common.ExportedFiles,
      },
      {
        path: "",
        
        displayText: "",
      },
    ],
  },
  {
    path: "Support",
    displayText: TranslationKeys.Common.Support,
    children: [
      {
        path: "",
        
        displayText: " ",
      },
      {
        path: ":id",
        
        displayText: TranslationKeys.Common.Support,
      },
      {
        path: "CreateCase",
        
        displayText: TranslationKeys.Common.Support,
      },
      {
        path: "Team",
        
        displayText: TranslationKeys.Common.MeetTheTeam,
      },
    ],
  },
  {
    path: "Supplier",
    displayText: TranslationKeys.Supplier.Supplier,
    backNavigationPath: "Reports/Suppliers",
    children: [
      {
        path: ":id/Settings",
        
        displayText: TranslationKeys.Common.Settings,
      },
      {
        path: ":id",
        
        displayText: TranslationKeys.Supplier.Supplier,
      },
    ],
  },
  {
    path: "QualifiedShareDividend",
    displayText: TranslationKeys.Common.K10Forms,
    backNavigationPath: "Reports/QualifiedShareDividend",
    children: [
      {
        path: ":id",
        
      },
    ],
  },
  {
    path: "PaymentMethod",
    displayText: TranslationKeys.Common.PaymentMethod,
    children: [
      {
        path: ":id",
        
        displayText: TranslationKeys.Common.PaymentMethod,
      },
    ],
  },
  {
    path: "Employees",
    displayText: TranslationKeys.Common.Employees,
    disableBackNavigation: true,
    children: [
      {
        path: "Salaries",
        displayText: TranslationKeys.Company.Salaries,
        backNavigationPath: "Employees/Salaries",
        children: [
          {
            path: "Edit",
            
            displayText: TranslationKeys.Salary.EditSalary,
          },
          {
            path: "",
            
            displayText: "",
          },
          {
            path: ":id",
            
          },
          {
            path: "Specifications",
            
            displayText: TranslationKeys.Salary.SalarySpecifications,
          },
        ],
      },
      {
        path: "Deviations",
        
        displayText: TranslationKeys.SalaryDeviation.Deviations,
      },
      {
        path: "WintDeviations",
        
        displayText: TranslationKeys.SalaryDeviation.Deviations,
      },
      {
        path: "Commission",
        
        displayText: TranslationKeys.Common.Commission,
      },
      {
        path: "BusinessUnits",
        
        displayText: TranslationKeys.BusinessUnit.BusinessUnits,
      },
      {
        path: "GrossSalaries",
        
        displayText: TranslationKeys.Salary.Salaries,
      },
      {
        path: "Benefits",
        
        displayText: TranslationKeys.Benefit.BenefitsTitle,
      },
      {
        path: "WintSalaries",
        
        displayText: TranslationKeys.Company.Salaries,
      },
    ],
  },
  {
    path: "Settings",
    
    displayText: TranslationKeys.Common.Settings,
  },
  {
    path: "Login",
    
    displayText: TranslationKeys.Common.Logout,
  },
  {
    path: "IncomingInvoice",
    displayText: TranslationKeys.IncomingInvoice.IncomingInvoices,
    backNavigationPath: "Reports/Expenses/IncomingInvoices",
    children: [
      {
        path: ":id",
        
        displayText: TranslationKeys.IncomingInvoice.IncomingInvoices,
      },
    ],
  },
  {
    path: "Receipt",
    displayText: TranslationKeys.Receipt.Receipt,
    backNavigationPath: "Reports/Expenses/Receipts",
    children: [
      {
        path: ":id",
        
        displayText: TranslationKeys.Receipt.Receipt,
      },
    ],
  },
  {
    path: "Customer",
    displayText: TranslationKeys.Invoice.Customer,
    backNavigationPath: "Reports/Customers",
    children: [
      {
        path: "Create",
        
        displayText: TranslationKeys.Invoice.CreateClient,
      },
      {
        path: ":id/Settings",
        
        displayText: TranslationKeys.Customer.CustomerSettings,
      },
      {
        path: ":id",
        
        displayText: TranslationKeys.Common.Customer,
      },
    ],
  },
  {
    path: "Projects",
    displayText: TranslationKeys.TimeReportingProject.TimeReportingProjects,
    backNavigationPath: "Reports/Projects",
    children: [
      {
        path: "Create",
        
        displayText: TranslationKeys.TimeReportingProject.TimeReportingProjects,
      },
      {
        path: ":id/Settings",
        
        displayText: TranslationKeys.TimeReportingProject.TimeReportingProjects,
      },
      {
        path: ":id",
        
        displayText: TranslationKeys.TimeReportingProject.TimeReportingProjects,
      },
    ],
  },
  {
    path: "Invoice",
    displayText: TranslationKeys.Common.Invoice,
    backNavigationPath: "Reports/Revenue/Invoices",
    children: [
      {
        path: "Create",
        
        displayText: TranslationKeys.Invoice.CreateInvoice,
      },
      {
        path: ":id",
        
        displayText: TranslationKeys.Common.Invoice,
      },
    ],
  },
  {
    path: "RecurringInvoice",
    displayText: TranslationKeys.Invoice.RecurringInvoice,
    backNavigationPath: "Reports/Revenue/RecurringInvoices",
    children: [
      {
        path: ":id",
        
        displayText: "Recurring invoice",
      },
    ],
  },
  {
    path: "Article",
    displayText: TranslationKeys.Common.Articles,
    backNavigationPath: "Reports/Articles",
    children: [
      {
        path: ":id/Settings",
        
        displayText: TranslationKeys.Common.Settings,
      },
      {
        path: ":id",
        
        displayText: TranslationKeys.Common.Articles,
      },
    ],
  },
  {
    path: "Employee",
    displayText: TranslationKeys.Common.Employee,
    disableBackNavigation: true,
    children: [
      {
        path: "Create",
        
      },
      {
        path: ":id",
        
      },
    ],
  },
  {
    path: "CashReconciliation",
    displayText: TranslationKeys.CashReconciliation.CashReconciliation,
    backNavigationPath: "Reports/Revenue/CashReconciliations",
    children: [
      {
        path: ":id",
        
        displayText: TranslationKeys.CashReconciliation.CashReconciliation,
      },
    ],
  },
  {
    path: "RevenueReport",
    displayText: TranslationKeys.RevenueReporting.Reports,
    backNavigationPath: "Reports/Revenue/CashReconciliations",
    children: [
      {
        path: ":id",
        
        displayText: TranslationKeys.RevenueReporting.Reports,
      },
    ],
  },
  {
    path: "AccountingDocument",
    displayText: TranslationKeys.Document.GenericDocuments,
    backNavigationPath: "Reports/AccountingDocuments",
    children: [
      {
        path: ":id",
        
        displayText: TranslationKeys.Document.GenericDocuments,
      },
    ],
  },
  {
    path: "FinancialStatement",
    displayText: TranslationKeys.AnnualAccount.AnnualAccounts,
    backNavigationPath: "Reports/FinancialStatements",
    children: [
      {
        path: ":id",
        
        displayText: TranslationKeys.AnnualAccount.AnnualAccounts,
      },
      {
        path: ":id/:reportType",
        
        displayText: TranslationKeys.AnnualAccount.AnnualAccounts,
      },
    ],
  },
  {
    path: "BusinessUnits",
    displayText: TranslationKeys.BusinessUnit.BusinessUnits,
    backNavigationPath: "Reports/BusinessUnits",
    children: [
      {
        path: "Create",
        
        displayText: TranslationKeys.BusinessUnit.CreateBusinessUnit,
      },
      {
        path: ":id/Settings",
        
        displayText: TranslationKeys.BusinessUnit.EditBusinessUnit,
      },
      {
        path: ":id",
        
        displayText: "Need to add display text",
      },
    ],
  },
  {
    path: "Quotation",
    displayText: TranslationKeys.Common.Quotation,
    backNavigationPath: "Reports/Quotes",
    children: [
      {
        path: "Create",
        
        displayText: TranslationKeys.Quotation.CreateQuotation,
      },
      {
        path: ":id",
        
        displayText: TranslationKeys.Common.Quotation,
      },
    ],
  },
  {
    path: "Voucher",
    displayText: TranslationKeys.Accounting.ManualPayment,
    backNavigationPath: "Reports/Accounting",
    children: [
      {
        path: ":id",
        
        displayText: TranslationKeys.Common.Accounting,
      },
    ],
  },
  {
    path: "Survey",
    displayText: TranslationKeys.Survey.Survey,
    children: [
      {
        path: ":id",
        
        displayText: TranslationKeys.Common.Submit2,
      },
    ],
  },
  {
    path: "TimeReport",
    displayText: TranslationKeys.TimeReporting.TimeReporting,
    children: [
      {
        path: "Weekly",
        
        displayText: TranslationKeys.TimeReporting.WeeklyTimeReport,
      },
      {
        path: "Monthly",
        
        displayText: TranslationKeys.TimeReporting.MonthlyTimeReport,
      },
    ],
  },
  {
    path: "Todo",
    displayText: "",
    children: [
      {
        path: ":id",
        
        displayText: TranslationKeys.Common.Todo,
      },
    ],
  },
  {
    path: "AdvisoryView",
    displayText: TranslationKeys.Reports.AdvisoryView,
    children: [
      {
        path: "ReconciliationReport",
        
        displayText: TranslationKeys.Accounting.Reconciliation,
      },
      {
        path: "DocumentationLog",
        
        displayText: TranslationKeys.Advisor.DocumentationLog,
      },
      {
        path: "MonthlyReports",
        displayText: TranslationKeys.Advisor.MonthlyReports,
        // The breadcrumb builds a crumb's href from this route's own `path` segment alone, so a
        // route nested below the top level has to spell out its full path here or the link drops
        // its ancestors (`/MonthlyReports` instead of `/AdvisoryView/MonthlyReports`). Same reason
        // Quotation carries `Reports/Quotes`.
        backNavigationPath: "AdvisoryView/MonthlyReports",
        children: [
          {
            path: ":id",
            
            displayText: TranslationKeys.Advisor.MonthlyReports,
          },
          {
            path: "",
            
            displayText: "",
          },
        ],
      },
      {
        path: "VatReports",
        displayText: TranslationKeys.Advisor.VatReports,
        // Spelled out in full for the breadcrumb, same as MonthlyReports above.
        backNavigationPath: "AdvisoryView/VatReports",
        children: [
          {
            path: ":id",
            
            displayText: TranslationKeys.Advisor.VatReports,
          },
          {
            path: "",
            
            displayText: "",
          },
        ],
      },
      {
        path: "EmailAddresses",
        
        displayText: TranslationKeys.Advisor.EmailAddresses,
      },
      {
        path: "",
        
        displayText: "",
      },
    ],
  },
  {
    path: "DocumentDraft",
    displayText: "",
    children: [
      {
        path: ":id",
        
        displayText: TranslationKeys.DocumentDraft.ReceivedDocuments,
      },
    ],
  },
  {
    path: "SelfInvoice",
    displayText: TranslationKeys.Invoice.SelfInvoice,
    disableBackNavigation: true,
    children: [
      {
        path: ":id",
        
        displayText: TranslationKeys.Invoice.CreateInvoice,
      },
    ],
  },
  {
    path: "MonthlyReports",
    displayText: TranslationKeys.MonthlyReport.Title,
    disableBackNavigation: true,
    children: [
      {
        path: ":id",
        
        displayText: TranslationKeys.MonthlyReport.Title,
      },
    ],
  },
];
